import './styles.css';
import { GameApp } from './app/GameApp.js';
import { LocalCoopIntegration } from './local-coop/LocalCoopIntegration.js';
import { MultiplayerIntegration } from './multiplayer/MultiplayerIntegration.js';
import { MultiplayerPlayerSnakesIntegration } from './multiplayer/MultiplayerPlayerSnakesIntegration.js';
import { RenderingIntegration } from './rendering/RenderingIntegration.js';

const mount = document.querySelector('#app');
const app = new GameApp({ mount });
app.start();

const multiplayer = new MultiplayerIntegration({ app });
multiplayer.install();

const rendering = new RenderingIntegration({ app, mount });
rendering.install();

const multiplayerPlayerSnakes = new MultiplayerPlayerSnakesIntegration({ app });
multiplayerPlayerSnakes.install();

const localCoop = new LocalCoopIntegration({ app });
localCoop.install();
